import { render, staticRenderFns } from "./direct-sales-proposals-create.page.vue?vue&type=template&id=0cca928a&scoped=true"
import script from "./direct-sales-proposals-create.page.vue?vue&type=script&lang=ts"
export * from "./direct-sales-proposals-create.page.vue?vue&type=script&lang=ts"
import style0 from "./direct-sales-proposals-create.page.vue?vue&type=style&index=0&id=0cca928a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cca928a",
  null
  
)

export default component.exports